import { alpha, Slider, styled, Grid, FormControl, Tab, Link, Table, Box } from '@mui/material';
import { Card, TextField, Typography, Button } from '@totalsoft/rocket-ui';
import { ThemedTypography } from 'components/common/CommonStyles';

export const FilterSliderLabel = styled(Typography)(({ theme }) => ({
  color: alpha(theme.palette.primary.main, 0.6)
}));

export const StyledFilterSlider = styled(Slider, { shouldForwardProp: prop => !['error'].includes(prop) })(({ theme, error }) => ({
  color: error ? theme.palette.error.main : theme.palette.primary.main,
  '& .MuiSlider-valueLabel': {
    backgroundColor: error ? theme.palette.error.main : theme.palette.primary.main,
    borderRadius: '4px',
    bottom: '-75px',
    top: 'auto',
    '&::before': {
      bottom: 'auto',
      top: '-8px'
    }
  }
}));

export const FilterSliderFieldWrapper = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '4px',
  display: 'flex',
  flexWrap: 'initial',
  width: '120px',
  alignItems: 'center'
}));

export const FilterSliderLabelWrapper = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const FilterSliderFieldLabelWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200]
}));

export const FilterSliderFieldValue = styled(TextField)(({ theme }) => ({
  padding: theme.spacing(0.75),
  minWidth: '50px',
  '& .MuiInput-input': {
    paddingBlock: 0
  }
}));

export const FilterSliderFieldLabelDropdown = styled(TextField)(({ theme }) => ({
  padding: theme.spacing(0.75),
  '& .MuiSelect-select': {
    fontWeight: 600,
    paddingBlock: 0,
    '&:focus': {
      backgroundColor: theme.palette.grey[200]
    }
  }
}));

export const FilterSliderFieldLabelText = styled(Typography, { shouldForwardProp: prop => !['disabled'].includes(prop) })(
  ({ theme, disabled }) => ({
    padding: theme.spacing(0.75),
    fontWeight: 500,
    fontSize: '14px',
    color: disabled ? alpha(theme.palette.primary.main, 0.6) : 1
  })
);

export const FilterSliderLoadingFormControl = styled(FormControl)(() => ({
  width: '100%'
}));

export const ProductSelectionViewModesWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  flexGrow: 1,
  fontWeight: theme.typography.fontWeightBold,
  gap: theme.spacing(1),
  '& .MuiTabs-indicator': {
    width: '60px !important'
  }
}));

export const ProductSelectionViewModesTab = styled(Tab)(({ theme }) => ({
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1),
  minWidth: '60px',
  borderRadius: theme.spacing(1)
}));

export const ProductSelectionFiltersTitle = styled(Link, { shouldForwardProp: prop => !['readOnly'].includes(prop) })(
  ({ theme, readOnly }) => ({
    fontSize: '18px',
    fontWeight: theme.typography.fontWeightBold,
    pointerEvents: readOnly ? 'none' : 'auto',
    cursor: 'pointer'
  })
);

export const ContractSelectionTableWrapper = styled(Table)(({ theme }) => ({
  '& td, th': {
    paddingBlock: theme.spacing(0.5)
  },
  '& .checkboxColumn': {
    width: '70px'
  }
}));

export const ProductCard = styled(Card, { shouldForwardProp: prop => !['disabled', 'selected'].includes(prop) })(
  ({ theme, disabled, selected }) => ({
    '& .MuiCardHeader-avatar': {
      minWidth: theme.spacing(6),
      width: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(1),
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold
    },
    opacity: disabled ? 0.4 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    ...(selected && {
      border: '1px solid',
      borderColor: theme.palette.secondary.main,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[20]
    })
  })
);

export const ProductSelectButton = styled(Button, { shouldForwardProp: prop => !['selected'].includes(prop) })(({ theme, selected }) => ({
  backgroundColor: selected ? theme.palette.secondary.main : theme.palette.primary.main,
  '&.Mui-disabled': {
    backgroundColor: selected ? theme.palette.secondary.main : 'inherit',
    color: theme.palette.common.white,
    opacity: 0.7
  }
}));

export const ProductServiceMonthyValueWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}));

export const ProductMessageText = styled(ThemedTypography)(() => ({
  fontSize: '15px',
  display: 'inline'
}));
export const   ProductNameText=styled(ThemedTypography) (() => ({
  flex: 1,
  whiteSpace: 'normal',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  textTransform:'uppercase' ,
  fontWeight:'bold' ,
  variant:'subtitle1'
}));
